<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="265"> </caass-schoolselector>
						</div>
					</div>

					<!--BalLo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Balance Minimum $</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="BalLoID" [(ngModel)]="report.BalLoID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of BalLoList" [ngValue]="o.MinAmt">
									{{ o.MinAmtDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--BalHi-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Balance Maximum $</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="BalHiID" [(ngModel)]="report.BalHiID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of BalHiList" [ngValue]="o.MaxAmt">
									{{ o.MaxAmtDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--SortBy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortByID" [(ngModel)]="report.SortByID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SortByList" [ngValue]="o.SortByID">
									{{ o.SortByName }}
								</option>
							</select>
						</div>
					</div>

					<!--StudentStatus-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Student Status</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="StudentStatusID" [(ngModel)]="report.StudentStatusID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of StudentStatusList" [ngValue]="o.StudentStatusID">
									{{ o.StudentStatusName }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
